export const EVENTDETAILS = 'EVENTDETAILS'

export const EVENTDETAILS_action = (data) => {
    return {
        type: 'EVENTDETAILS',
        data: data
    }
}